module.exports = __webpack_public_path__ + "img/zx5.145bc163.png";